import Alert from '@web/components/Modal/Alert'
import { useModal } from '@web/components/Modal/useModal'
import nClicks from '@web/libs/nlog/click/codes'
import { ModalProps } from '@web/types'

interface Props {
  onConfirm?: ModalProps['confirmModal']
}
export const useNotMobileModal = (props?: Props) => {
  const { openModal: openNotMobileModal } = useModal(Alert, {
    label: { confirm: '확인' },
    title: (
      <>
        방문 인증은
        <br />
        모바일 환경에서만
        <br />
        가능합니다
      </>
    ),
    callback: {
      confirm: props?.onConfirm,
    },
    clickCodes: {
      confirm: nClicks.gnb.PC_POPUP,
    },
  })

  return {
    openNotMobileModal,
  }
}
